import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { apiFetch } from "../../api.js";
import { useLocation } from "react-router-dom";
import Select from "react-select";

//-----------------------------BANK SECTION HEADER BAR
const BankSection = React.memo(
  ({
    open,
    amount,
    onAmountChange,
    bankName,
    setBankName,
    chequeNo,
    setChequeNo,
    chequeDate,
    setChequeDate,
    bankList,
    selectStyles,
  }) => {
    if (!open) return null;
    return (
      <div className="payment-box bank-aspx">
        <div className="bank-row">
          <div className="bank-col">
            <label>Bank Name</label>
            <Select
              options={bankList}
              value={bankList.find((b) => b.value === bankName) || null}
              onChange={(selected) => setBankName(selected?.value || "")}
              placeholder="Select Bank"
              styles={selectStyles}
              isSearchable
            />
          </div>
          <div className="bank-col">
            <label>Cheque No</label>
            <input
              value={chequeNo}
              onChange={(e) => setChequeNo(e.target.value)}
            />
          </div>
          <div className="bank-col">
            <label>Cheque Date</label>
            <input
              type="date"
              value={chequeDate}
              onChange={(e) => setChequeDate(e.target.value)}
            />
          </div>
          <div className="bank-col">
            <label>Cheque Amount</label>
            <input
              type="text"
              value={amount}
              onChange={(e) =>
                onAmountChange(Number(e.target.value.replace(/\D/g, "") || 0))
              }
            />
          </div>
        </div>
      </div>
    );
  },
);
//-----------------------------WALLET SECTION HEADER BAR
const WalletSection = React.memo(
  ({
    open,
    amount,
    onAmountChange,
    walletName,
    setWalletName,
    walletTxnCode,
    setWalletTxnCode,
  }) => {
    if (!open) return null;
    return (
      <div className="payment-box wallet-aspx">
        <div className="wallet-row">
          <div className="wallet-col">
            <label>Wallet Name</label>
            <input
              value={walletName}
              onChange={(e) => setWalletName(e.target.value)}
            />
          </div>
          <div className="wallet-col">
            <label>Transaction Code</label>
            <input
              value={walletTxnCode}
              onChange={(e) => setWalletTxnCode(e.target.value)}
            />
          </div>
          <div className="wallet-col">
            <label>Wallet Amount</label>
            <input
              type="text"
              value={amount}
              onChange={(e) =>
                onAmountChange(Number(e.target.value.replace(/\D/g, "") || 0))
              }
            />
          </div>
        </div>
      </div>
    );
  },
);

// ----------------------------- CREDIT CARD SECTION (FIXED)
const CreditCardSection = React.memo(
  ({
    open,
    amount,
    onAmountChange,
    ccName,
    setCcName,
    ccTxn,
    setCcTxn,
    ccLast4,
    setCcLast4,
    ccType,
    setCcType,
    ccDate,
    setCcDate,
    cardList,
    selectStyles,
  }) => {
    if (!open) return null;
    return (
      <div className="payment-box card-aspx">
        <div className="card-row">
          <div className="card-col">
            <label>Card Name</label>
            <Select
              options={cardList}
              value={cardList.find((c) => c.value === ccName) || null}
              onChange={(selected) => setCcName(selected?.value || "")}
              placeholder="Select Card"
              styles={selectStyles}
              isSearchable
            />
          </div>
          <div className="card-col">
            <label>Transaction Code</label>
            <input value={ccTxn} onChange={(e) => setCcTxn(e.target.value)} />
          </div>
          <div className="card-col">
            <label>Last 4 Digits</label>
            <input
              maxLength={4}
              value={ccLast4}
              onChange={(e) => setCcLast4(e.target.value.replace(/\D/g, ""))}
            />
          </div>
          <div className="card-col">
            <label>Card Type</label>
            <select value={ccType} onChange={(e) => setCcType(e.target.value)}>
              <option value="">Select</option>
              <option>Visa</option>
              <option>Master</option>
              <option>Rupay</option>
            </select>
          </div>
          <div className="card-col">
            <label>Card Date</label>
            <input
              type="date"
              value={ccDate}
              onChange={(e) => setCcDate(e.target.value)}
            />
          </div>
          <div className="card-col">
            <label>Amount</label>
            <input
              type="text"
              value={amount}
              onChange={(e) =>
                onAmountChange(Number(e.target.value.replace(/\D/g, "") || 0))
              }
            />
          </div>
        </div>
      </div>
    );
  },
);
// ----------------------------- DEBIT CARD SECTION (FIXED)
const DebitCardSection = React.memo(
  ({
    open,
    amount,
    onAmountChange,
    dcName,
    setDcName,
    dcTxn,
    setDcTxn,
    dcLast4,
    setDcLast4,
    dcType,
    setDcType,
    dcDate,
    setDcDate,
    cardList,
    selectStyles,
  }) => {
    if (!open) return null;
    return (
      <div className="payment-box card-aspx">
        <div className="card-row">
          <div className="card-col">
            <label>Debit Card Name</label>
            <Select
              options={cardList}
              value={cardList.find((c) => c.value === dcName) || null}
              onChange={(selected) => setDcName(selected?.value || "")}
              placeholder="Select Card"
              styles={selectStyles}
              isSearchable
            />
          </div>
          <div className="card-col">
            <label>Transaction Code</label>
            <input value={dcTxn} onChange={(e) => setDcTxn(e.target.value)} />
          </div>
          <div className="card-col">
            <label>Last 4 Digits</label>
            <input
              maxLength={4}
              value={dcLast4}
              onChange={(e) => setDcLast4(e.target.value.replace(/\D/g, ""))}
            />
          </div>
          <div className="card-col">
            <label>Card Type</label>
            <select value={dcType} onChange={(e) => setDcType(e.target.value)}>
              <option value="">Select</option>
              <option>Visa</option>
              <option>Master</option>
              <option>Rupay</option>
            </select>
          </div>
          <div className="card-col">
            <label>Card Date</label>
            <input
              type="date"
              value={dcDate}
              onChange={(e) => setDcDate(e.target.value)}
            />
          </div>
          <div className="card-col">
            <label>Amount</label>
            <input
              type="text"
              value={amount}
              onChange={(e) =>
                onAmountChange(Number(e.target.value.replace(/\D/g, "") || 0))
              }
            />
          </div>
        </div>
      </div>
    );
  },
);

// ----------------------------- UPI / RTGS SECTION (FIXED)
const UpiSection = React.memo(
  ({
    open,
    amount,
    onAmountChange,
    upiBankName,
    setUpiBankName,
    upiUtr,
    setUpiUtr,
    upiDate,
    setUpiDate,
    bankList,
    selectStyles,
  }) => {
    if (!open) return null;
    return (
      <div className="payment-box bank-aspx">
        <div className="bank-row">
          <div className="bank-col">
            <label>Bank Name</label>
            <Select
              options={bankList}
              value={bankList.find((b) => b.value === upiBankName) || null}
              onChange={(selected) => setUpiBankName(selected?.value || "")}
              placeholder="Select Bank"
              styles={selectStyles}
              isSearchable
            />
          </div>
          <div className="bank-col">
            <label>UTR / Transaction No</label>
            <input
              value={upiUtr}
              onChange={(e) => setUpiUtr(e.target.value)}
              placeholder="UTR / Transaction No"
            />
          </div>
          <div className="bank-col">
            <label>Date</label>
            <input
              type="date"
              value={upiDate}
              onChange={(e) => setUpiDate(e.target.value)}
            />
          </div>
          <div className="bank-col">
            <label>Amount</label>
            <input
              type="text"
              value={amount}
              onChange={(e) =>
                onAmountChange(Number(e.target.value.replace(/\D/g, "") || 0))
              }
            />
          </div>
        </div>
      </div>
    );
  },
);

const RajaReceiptDetailsDesign = () => {
  const allowAlphabets = (v) => v.replace(/[^a-zA-Z ]/g, "");
  const allowNumbers = (value) => value.replace(/[^0-9]/g, "");
  const location = useLocation();
  const editUnqid = location.state?.unqid || null;
  const [paymentType, setPaymentType] = useState("WITH");
  const [Branch, setBranch] = useState("");
  const [BranchList, setBranchList] = useState([]);
  const [TYPE, setTYPE] = useState("");
  const [receiptDate, setReceiptDate] = useState("");

  const [Receiptno, setReceiptno] = useState("");
  const [CustomerName, setCustomerName] = useState("");
  const [CustomerNameList, setCustomerNameList] = useState([]);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [showCityModal, setShowCityModal] = useState(false);
  const [showAreaModal, setshowAreaModal] = useState(false);
  const [showHypothecationModal, setshowHypothecationModal] = useState(false);
  const [Address, setAddress] = useState("");
  const [PANNo, setPANNo] = useState("");
  const [Aadharno, setAadharno] = useState("");
  const [GSTIN, setGSTIN] = useState("");
  const [AccessoriesInvoiceNo, setAccessoriesInvoiceNo] = useState("");
  const [State, setState] = useState("");
  const [StateList, setStateList] = useState([]);
  const [City, setCity] = useState("");
  const [CityList, setCityList] = useState([]);
  const [Area, setArea] = useState("");
  const [AreaList, setAreaList] = useState([]);
  const [ZipNo, setZipNo] = useState("");
  const [Model, setModel] = useState("");
  const [ModelList, setModelList] = useState([]);
  const [Variant, setVariant] = useState("");
  const [VariantList, setVariantList] = useState([]);
  const [Color, setColor] = useState("");
  const [ColorList, setColorList] = useState([]);
  const [Fuel, setFuel] = useState("");
  const [Scname, setScname] = useState("");
  const [ScnameList, setScnameList] = useState([]);
  const [Tlname, setTlname] = useState("");
  const [Manager, setManager] = useState("");
  const [Hypothecation, setHypothecation] = useState("");
  const [HypothecationList, setHypothecationList] = useState([]);
  const [HypothecationBranch, setHypothecationBranch] = useState("");
  const [HypothecationBranchList, setHypothecationBranchList] = useState([]);
  const [Amount, setAmount] = useState("");
  const [Modeofpayment, setModeofpayment] = useState("");
  const [Remark, setRemark] = useState("");
  const [imageUpload, setImageUpload] = useState(null);
  const [bankAmt, setBankAmt] = useState(0);
  const [walletAmt, setWalletAmt] = useState(0);
  const [creditAmt, setCreditAmt] = useState(0);
  const [debitAmt, setDebitAmt] = useState(0);
  const [cashAmt, setCashAmt] = useState(0);
  const [upiBankName, setUpiBankName] = useState("");
  const [upiUtr, setUpiUtr] = useState("");
  const [upiDate, setUpiDate] = useState("");
  const [upiAmt, setUpiAmt] = useState(0);
  const [insuranceDocumentpdf, setInsuranceDocumentpdf] = useState(null);
  const [filePath1, setFilePath1] = useState("");
  const [filePath2, setFilePath2] = useState("");
  const grandTotal =
    bankAmt + walletAmt + creditAmt + debitAmt + cashAmt + upiAmt;
  const [showBank, setShowBank] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();
  const [customerSearch, setCustomerSearch] = useState("");
  const [customerSuggestions, setCustomerSuggestions] = useState([]);
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [scSearch, setScSearch] = useState("");
  const [scSuggestions, setScSuggestions] = useState([]);
  const [showScDropdown, setShowScDropdown] = useState(false);
  const [selectedCustomerLabel, setSelectedCustomerLabel] = useState("");
  const [activePayment, setActivePayment] = useState("Bank");
  const [openSection, setOpenSection] = useState(null);
  const [modalState, setModalState] = useState("");
  const [modalCity, setModalCity] = useState("");
  const [modalArea, setModalArea] = useState("");
  const [modalCityList, setModalCityList] = useState([]);
  const [modalAreaList, setModalAreaList] = useState([]);
  const [accTitle, setAccTitle] = useState("MR");
  const [accName, setAccName] = useState("");
  const [accEmail, setAccEmail] = useState("");
  const [accAddress, setAccAddress] = useState("");
  const [accZip, setAccZip] = useState("");
  const [accMobile, setAccMobile] = useState("");
  const [accGSTIN, setAccGSTIN] = useState("");
  const [accAadhar, setAccAadhar] = useState("");
  const [accPAN, setAccPAN] = useState("");
  const [accDob, setAccDob] = useState("");
  const [accAnniv, setAccAnniv] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const [newCityState, setNewCityState] = useState("");
  const [newCityName, setNewCityName] = useState("");
  const [newAreaCity, setNewAreaCity] = useState("");
  const [newAreaName, setNewAreaName] = useState("");
  const [newCityStateName, setNewCityStateName] = useState("");
  const [newAreaCityUnqid, setNewAreaCityUnqid] = useState("");
  const [newAreaCityName, setNewAreaCityName] = useState("");
  const [cityPopupSource, setCityPopupSource] = useState("");
  const [hypoBankName, setHypoBankName] = useState("");
  const [hypoBankAddress, setHypoBankAddress] = useState("");
  const [stateId, setStateId] = useState("");
  const [stateName, setStateName] = useState("");
  const [bankName, setBankName] = useState("");
  const [chequeNo, setChequeNo] = useState("");
  const [chequeDate, setChequeDate] = useState("");
  const [walletName, setWalletName] = useState("");
  const [walletTxnCode, setWalletTxnCode] = useState("");
  const [ccName, setCcName] = useState("");
  const [ccTxn, setCcTxn] = useState("");
  const [ccLast4, setCcLast4] = useState("");
  const [ccType, setCcType] = useState("");
  const [ccDate, setCcDate] = useState("");
  const [dcName, setDcName] = useState("");
  const [dcTxn, setDcTxn] = useState("");
  const [dcLast4, setDcLast4] = useState("");
  const [dcType, setDcType] = useState("");
  const [dcDate, setDcDate] = useState("");
  const [cardList, setCardList] = useState([]);
  const [bankList, setBankList] = useState([]);

  const TypeList = [
    { value: "Accessories", label: "Accessories" },
    { value: "Booking", label: "Booking" },
    { value: "Counter Sale", label: "Counter Sale" },
    { value: "Extended Warranty", label: "Extended Warranty" },
    { value: "FastTag", label: "FastTag" },
    { value: "Finance", label: "Finance" },
    { value: "Insurance", label: "Insurance" },
    { value: "Other", label: "Other" },
    { value: "Payout", label: "Payout" },
    { value: "Road Side Assistance", label: "Road Side Assistance" },
    { value: "Shield Of Trust", label: "Shield Of Trust" },
    { value: "UsedCar", label: "UsedCar" },
    { value: "WorkShop", label: "WorkShop" },
  ];

  const ModeOfPaymentList = [
    { value: "Bank", label: "Cheque" },
    { value: "wallet", label: "Wallet" },
    { value: "CreditCard", label: "Credit Card" },
    { value: "DebitCard", label: "Debit Card" },
    { value: "cash", label: "Cash" },
    { value: "UPI", label: "UPI" },
    { value: "RTGS", label: "RTGS / NEFT / IMPS" },
  ];

  useEffect(() => {
    fetchModels();
    fetchColors();
  }, []);

  useEffect(() => {
    if (Model) fetchVariants(Model);
    else setVariantList([]);
  }, [Model]);

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "40px",
      height: "40px",
      borderRadius: "5px",
      borderColor: "#ccc",
      boxShadow: "none",
      fontSize: "14px",
    }),

    valueContainer: (base) => ({
      ...base,
      height: "40px",
      padding: "0 8px",
    }),

    indicatorsContainer: (base) => ({
      ...base,
      height: "40px",
    }),

    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),

    menu: (base) => ({
      ...base,
      width: "100%", // 🔥 THIS FIXES YOUR ISSUE
      minWidth: "100%",
    }),
  };

  const sectionHeaderStyle = {
    backgroundColor: "#8B1E3F",
    color: "#ffff",
    padding: "12px 15px",
    cursor: "pointer",
    fontWeight: "bold",
    marginTop: "15px",
    borderRadius: "4px",
  };

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    flexWrap: "nowrap", // 🔥 no wrapping (forces one row)
    width: "100%",
    marginTop: "30px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px",
    height: "44px",
    padding: "0 18px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  });

  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);
  //-----------------------------Receipt FILE UPLOAD PART
  const uploadFile = async (file) => {
    if (!file) {
      alert("Please select a file first");
      return "";
    }
    const formData = new FormData();
    formData.append("file", file);
    const res = await apiFetch(
      "/api/RajaReceipt/upload-file",
      { method: "POST", body: formData },
    );
    const data = await res.json();
    return data.filePath;
  };
  //-----------------------------Receipt  SECTION HEADER BAR
  const SectionHeader = ({ title, icon, amount, open, onToggle }) => (
    <div
      style={{
        background: "#8B1E3F",
        color: "white",
        padding: "10px 15px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer",
        borderRadius: "4px",
        marginTop: "15px",
      }}
      onClick={onToggle}
    >
      <b>
        <i className={icon}></i>&nbsp; {title}
      </b>

      <div>
        <b>Amount : ₹ {amount || 0}</b>&nbsp;&nbsp;
        <b style={{ fontSize: "18px" }}>{open ? "−" : "+"}</b>
      </div>
    </div>
  );

  //-----------------------------CASH SECTION HEADER BAR
  const denominations = [500, 200, 100, 50, 20, 10, 5];
  const splitCashIntoNotes = (amount) => {
    let remaining = amount;
    const result = {};
    denominations.forEach((d) => {
      result[d] = Math.floor(remaining / d);
      remaining = remaining % d;
    });
    return result;
  };
  const CashSection = ({ open, amountReceived, onAmountChange }) => {
    const denominations = [500, 200, 100, 50, 20, 10, 5];
    const [counts, setCounts] = useState(
      denominations.reduce((a, d) => ({ ...a, [d]: 0 }), {}),
    );
    useEffect(() => {
      if (amountReceived > 0) {
        let remaining = Number(amountReceived);
        const autoCounts = {};
        denominations.forEach((d) => {
          autoCounts[d] = Math.floor(remaining / d);
          remaining %= d;
        });
        setCounts(autoCounts);
      }
    }, [amountReceived]);
    const handleChange = (denom, value) => {
      setCounts((prev) => ({
        ...prev,
        [denom]: Number(value || 0),
      }));
    };
    const totalNotes = denominations.reduce(
      (sum, d) => sum + (counts[d] || 0),
      0,
    );
    const totalCash = denominations.reduce(
      (sum, d) => sum + d * (counts[d] || 0),
      0,
    );
    if (!open) return null;
    return (
      <div className="cash-wrapper">
        {/* LEFT */}
        <div>
          {denominations.map((d) => (
            <div key={d} className="cash-row-line">
              <b>{d}</b>
              <span>*</span>
              <input
                type="number"
                min="0"
                value={counts[d]}
                onChange={(e) => handleChange(d, e.target.value)}
              />
              <span>=</span>
              <input type="text" value={d * counts[d]} readOnly />
            </div>
          ))}

          <div style={{ marginTop: "12px" }}>
            <b>Total Notes Count</b>
            <input type="text" value={totalNotes} readOnly />
          </div>
        </div>

        {/* RIGHT */}
        <div className="cash-summary">
          <b>Total Cash Received</b>
          <input type="text" value={totalCash} readOnly />

          <br />
          <br />

          <b>Total Amount</b>
          <input
            type="text"
            value={totalCash}
            readOnly
            style={{ background: "#eee", fontWeight: "bold" }}
          />
        </div>
      </div>
    );
  };

  //-----------------------------RECEIIPT GET BRANCH LIST
  useEffect(() => {
    fetchBranchList();
  }, []);
  const fetchBranchList = async () => {
    try {
      const response = await apiFetch(
        "/api/receipt/branch-list",
        { method: "POST", body: JSON.stringify({ branch_unqid: Branch }) },
      );
      const data = await response.json();
      if (data.err === "0") {
        setBranchList(data.list.map((x) => ({ value: x.data, label: x.value })));
        if (data.selected) setBranch(data.selected.bunq);
      }
    } catch (err) {
      console.error("❌ Error loading branches", err);
    }
  };
  //-----------------------------RECEIIPT  RECEIPTNO LIST
  useEffect(() => {
    if (!editUnqid) {
      fetchReceiptNo();
    }
  }, [editUnqid]);

  const fetchReceiptNo = async () => {
    try {
      const response = await apiFetch(
        "/api/receipt/next-receipt-no",
        { method: "POST", body: JSON.stringify({}) },
      );
      const data = await response.json();
      if (data.err === "0") setReceiptno(data.mx.toString());
      console.log(data);
    } catch (err) {
      console.error("❌ Error fetching receipt no", err);
    }
  };
  //-----------------------------RECEIIPT  GET STATE LIST
  useEffect(() => {
    fetchStates();
  }, []);
  const fetchStates = async () => {
    try {
      const response = await apiFetch(
        "/api/receipt/states",
        { method: "POST" },
      );
      const data = await response.json();
      setStateList(data.map((x) => ({ label: x.value, value: x.label })));
    } catch (err) {
      console.error("Error fetching states:", err);
    }
  };

  //-----------------------------RECEIIPT  GET CITY LIST
  useEffect(() => {
    if (State) fetchCities(State);
  }, [State]);
  const fetchCities = async (stateValue) => {
    try {
      const response = await apiFetch(
        "/api/receipt/cities",
        { method: "POST", body: JSON.stringify({ stateValue }) },
      );
      const data = await response.json();
      setCityList(data);
    } catch (err) {
      console.error("Error fetching cities:", err);
    }
  };
  //-----------------------------RECEIIPT  GET AREA LIST
  useEffect(() => {
    if (City) fetchAreas(City);
  }, [City]);
  const fetchAreas = async (cityValue) => {
    try {
      const response = await apiFetch(
        "/api/receipt/areas",
        { method: "POST", body: JSON.stringify({ cityValue }) },
      );
      const data = await response.json();
      setAreaList(data);
    } catch (err) {
      console.error("Error fetching areas:", err);
    }
  };
  //-----------------------------RECEIIPT  GET MODEL LIST
  useEffect(() => {
    fetchModels();
  }, []);
  const fetchModels = async () => {
    const response = await apiFetch(
      "/api/receipt/models",
      { method: "POST", body: JSON.stringify({}) },
    );
    const data = await response.json();
    setModelList(data.map((m) => ({ value: m.label, label: m.value })));
  };
  //-----------------------------RECEIIPT  GET VARIANT LIST
  useEffect(() => {
    if (Model) fetchVariants(Model);
    else setVariantList([]);
  }, [Model]);
  const fetchVariants = async (modelUnqid) => {
    const response = await apiFetch(
      "/api/receipt/variants",
      { method: "POST", body: JSON.stringify({ modelUnqid }) },
    );
    const data = await response.json();
    setVariantList(data.map((v) => ({ value: v.label, label: v.value })));
  };
  //-----------------------------RECEIIPT  GET COLOR LIST
  useEffect(() => {
    fetchColors();
  }, []);

  const fetchColors = async () => {
    const response = await apiFetch(
      "/api/receipt/colors",
      { method: "POST", body: JSON.stringify({}) },
    );
    const data = await response.json();
    setColorList(data.map((c) => ({ value: c.label, label: c.value })));
  };
  //-----------------------------RECEIIPT SEARCH CUSTOMER NAME LIST
  const searchCustomer = async (text) => {
    if (text.length < 2) {
      setCustomerSuggestions([]);
      return;
    }
    try {
      const response = await apiFetch(
        "/api/receipt/customer-search",
        { method: "POST", body: JSON.stringify({ searchText: text }) },
      );
      const data = await response.json();
      if (data.err === "0") {
        setCustomerSuggestions(data.list || []);
        setShowCustomerDropdown(true);
      }
      console.log(data);
    } catch (err) {
      console.error("❌ Customer search failed", err);
    }
  };
  const handleCustomerInput = (e) => {
    const value = e.target.value;
    setCustomerSearch(value);
    searchCustomer(value);
  };
  //-----------------------------RECEIIPT  GET SCNAME LIST
  useEffect(() => {
    fetchSaleConsultants();
  }, []);
  const fetchSaleConsultants = async () => {
    const response = await apiFetch(
      "/api/receipt/sale-consultants",
      { method: "POST", body: JSON.stringify({}) },
    );
    const data = await response.json();
    setScnameList(data);
  };
  const searchSc = (text) => {
    const filtered = ScnameList.filter((sc) =>
      sc.label.toLowerCase().includes(text.toLowerCase()),
    );
    setScSuggestions(filtered);
    setShowScDropdown(true);
  };
  const handleScInput = (e) => {
    const value = e.target.value;
    setScSearch(value);
    setScname("");
    setTlname("");
    setManager("");
    if (value.length < 2) {
      setScSuggestions([]);
      setShowScDropdown(false);
      return;
    }
    searchSc(value);
  };
  //-----------------------------RECEIIPT FETCH TL NAME AND MANAGER NAME BY SC ANME
  const loadTlManagerBySc = async (scUnqid) => {
    const response = await apiFetch(
      "/api/receipt/checkedit",
      { method: "POST", body: JSON.stringify({ rcl_81: scUnqid }) },
    );
    const data = await response.json();
    if (data.err === "0") {
      setTlname(data.tl || "");
      setManager(data.manager || "");
    }
  };
  //-----------------------------RECEIIPT  GET HYPOTHECATION
  useEffect(() => {
    fetchHypothecation();
  }, []);
  const fetchHypothecation = async () => {
    try {
      const response = await apiFetch(
        "/api/receipt/hypothecation",
        { method: "POST", body: JSON.stringify({}) },
      );
      const data = await response.json();
      if (data.err === "0") {
        setHypothecationList(data.list.map((x) => ({ value: x.data, label: x.value })));
      }
    } catch (err) {
      console.error("❌ Error loading hypothecation", err);
    }
  };
  //-----------------------------RECEIIPT  GET HYPOTHECATION BRANCH
  useEffect(() => {
    if (Hypothecation) {
      fetchHypothecationBranch(Hypothecation);
    } else {
      setHypothecationBranchList([]);
      setHypothecationBranch("");
    }
  }, [Hypothecation]);

  const fetchHypothecationBranch = async (hpUnqid) => {
    try {
      const response = await apiFetch(
        "/api/receipt/hypothecation-branch",
        { method: "POST", body: JSON.stringify({ hp_unqid: hpUnqid }) },
      );
      const data = await response.json();
      if (data.err === "0" && Array.isArray(data.list)) {
        setHypothecationBranchList(data.list.map((x) => ({ value: x.data, label: x.value })));
      } else {
        setHypothecationBranchList([]);
        setHypothecationBranch("");
      }
    } catch (err) {
      console.error("❌ Hypothecation branch fetch failed", err);
      setHypothecationBranchList([]);
    }
  };

  //-----------------------------RECEIIPT  GET STATE CITY AREA
  useEffect(() => {
    if (modalState) {
      fetchModalCities(modalState);
      setModalCity("");
      setModalArea("");
      setModalAreaList([]);
    }
  }, [modalState]);

  useEffect(() => {
    if (modalCity) {
      fetchModalAreas(modalCity);
      setModalArea("");
    }
  }, [modalCity]);
  //Raja Receipt Popup city fetch
  const fetchModalCities = async (stateValue) => {
    const response = await apiFetch(
      "/api/receipt/cities",
      { method: "POST", body: JSON.stringify({ stateValue }) },
    );
    const data = await response.json();
    setModalCityList(data);
  };
  //Raja Receipt Popup area fetch
  const fetchModalAreas = async (cityValue) => {
    const response = await apiFetch(
      "/api/receipt/areas",
      { method: "POST", body: JSON.stringify({ cityValue }) },
    );
    const data = await response.json();
    setModalAreaList(data);
  };
  //-----------------------------RECEIIPT  ACCOUNTMODEL SAVE
  const saveAccountFromModal = async () => {
    try {
      const response = await apiFetch(
        "/api/receipt/accountmaster/insert",
        {
          method: "POST",
          body: JSON.stringify({
            title: accTitle,
            accountHeadName: accName,
            printName: accName,
            address: accAddress,
            state: modalState,
            city: modalCity,
            area: modalArea,
            zip: accZip,
            mobile: accMobile,
            email: accEmail,
            gstin: accGSTIN,
            pan: accPAN,
            aadhar: accAadhar,
            dob: accDob,
            anniversary: accAnniv,
            ipAddress,
            userId,
          }),
        },
      );
      const data = await response.json();
      if (data.success) {
        setCustomerSearch(accName);
        setCustomerName(data.unqid);
        setAddress(accAddress);
        setState(modalState);
        setCity(modalCity);
        setArea(modalArea);
        setZipNo(accZip);
        setShowAccountModal(false);
        setAccName("");
        setAccAddress("");
        setAccMobile("");
        alert("Account created successfully");
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Failed to save account");
    }
  };
  //-----------------------------RECEIIPT  ACCOUNTMODEL CITY CODE
  useEffect(() => {
    if (showCityModal && modalState) {
      const selectedState = StateList.find((s) => s.label === modalState);
      if (selectedState) {
        setNewCityState(modalState);
        setNewCityStateName(selectedState.value);
      }
    }
  }, [showCityModal, modalState, StateList]);
  //-----------------------------RECEIIPT  ACCOUNTMODEL POPUP CITY SAVE
  const saveCity = async () => {
    if (!newCityStateName || !newCityName) {
      alert("State and City are required");
      return;
    }
    try {
      const response = await apiFetch(
        "/api/receipt/city/insert",
        { method: "POST", body: JSON.stringify({ state: newCityStateName, city: newCityName }) },
      );
      const data = await response.json();
      if (data.success) {
        alert(data.message);
        setShowCityModal(false);
        setNewCityState("");
        setNewCityName("");
        fetchCities(newCityStateName);
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Failed to save city");
    }
  };
  //-----------------------------RECEIIPT  ACCOUNTMODEL AREA
  useEffect(() => {
    if (showAreaModal && modalCity) {
      const selectedCity = modalCityList.find((c) => c.value === modalCity);
      if (selectedCity) {
        setNewAreaCityUnqid(selectedCity.value);
        setNewAreaCityName(selectedCity.label);
      }
    }
  }, [showAreaModal, modalCity, modalCityList]);
  //-----------------------------RECEIIPT  ACCOUNTMODEL POPUP AREA SAVE
  const saveArea = async () => {
    if (!newAreaCityUnqid || !newAreaName) {
      alert("City and Area are required");
      return;
    }
    try {
      const response = await apiFetch(
        "/api/receipt/area/insert",
        { method: "POST", body: JSON.stringify({ city: newAreaCityUnqid, area: newAreaName }) },
      );
      const data = await response.json();
      alert(data.message);
      if (data.success) {
        setshowAreaModal(false);
        setNewAreaName("");
        fetchAreas(modalCity);
      }
    } catch (err) {
      alert("Server error");
    }
  };
  //-----------------------------RECEIIPT MAIN CITY SAVE
  const saveMainCity = async () => {
    if (!newCityStateName || !newCityName) {
      alert("State and City required");
      return;
    }
    try {
      const cityResponse = await apiFetch(
        "/api/receipt/city/insert",
        { method: "POST", body: JSON.stringify({ state: newCityStateName, city: newCityName }) },
      );
      const cityData = await cityResponse.json();
      if (cityData.success) {
        alert(cityData.message);
        const resCityResponse = await apiFetch(
          "/api/receipt/cities",
          { method: "POST", body: JSON.stringify({ stateValue: newCityStateName }) },
        );
        const data = await resCityResponse.json();
        setCityList(data);
        const addedCity = data.find((c) => c.label.toLowerCase() === newCityName.toLowerCase());
        if (addedCity) setCity(addedCity.value);
        setShowCityModal(false);
        setNewCityName("");
      } else {
        alert(cityData.message);
      }
    } catch (err) {
      console.error(err);
      alert("Failed to save city");
    }
  };
  //-----------------------------RECEIIPT  HYPOTHECATION POPUP SAVE
  const savehpn = async () => {
    try {
      if (!hypoBankName || !hypoBankAddress) {
        alert("Bank Name & Address are required");
        return;
      }
      const parentResponse = await apiFetch(
        "/api/receipt/hypothecation/save-parent",
        {
          method: "POST",
          body: JSON.stringify({
            BankName: hypoBankName,
            Address: hypoBankAddress,
            City: City || "",
            State: State || "",
            Country: "India",
            Emailone: "",
            CompanyAuthorised: "",
            Contactpersonone: "",
            Designationone: "",
            Mobilenoone: "",
            Contactpersontwo: "",
            Designationtwo: "",
            Mobilenotwo: "",
            Contactpersonthree: "",
            Designationthree: "",
            Mobilenothree: "",
            userid: storedUserInfo?.userId || "",
            ipAddress,
          }),
        },
      );
      const parentRes = await parentResponse.json();
      if (parentRes.err === "0") {
        alert(parentRes.msg || "Save failed");
        return;
      }
      alert("Hypothecation Bank Saved Successfully");
      setshowHypothecationModal(false);
      fetchHypothecation();
    } catch (err) {
      console.error(err);
      alert("Error saving hypothecation");
    }
  };

  const handleSaveReceipt = async () => {
    try {
      const payload = {};
      const dateFields = [7, 14, 115, 135];
      for (let i = 1; i <= 138; i++) {
        if (dateFields.includes(i)) {
          payload[`Rcl_${i}`] = "";
        } else {
          payload[`Rcl_${i}`] = null;
        }
      }
      payload.Rcl_3 = userId || "";
      payload.Rcl_4 = ipAddress || "";
      payload.Rcl_6 = serverIp || "";
      payload.Rcl_7 = receiptDate || "";
      payload.Rcl_8 = AccessoriesInvoiceNo || "";
      payload.Rcl_9 = Receiptno || "";
      payload.Rcl_10 = Hypothecation || "";
      payload.Rcl_11 = CustomerName || "";
      payload.Rcl_12 = Amount?.toString() || "0";
      payload.Rcl_16 = Modeofpayment || "";
      payload.Rcl_40 = "0";
      payload.Rcl_41 = "0";
      payload.Rcl_42 = "0";
      payload.Rcl_43 = "0";
      payload.Rcl_136 = "0";
      payload.Rcl_51 = grandTotal.toString();
      payload.Rcl_58 = grandTotal.toString();
      payload.Rcl_61 = grandTotal.toString();
      payload.Rcl_53 = accMobile || "";
      payload.Rcl_54 = customerSearch || "";
      payload.Rcl_56 = Scname || "";
      payload.Rcl_66 = TYPE || "";
      payload.Rcl_71 = Model || "";
      payload.Rcl_73 = Variant || "";
      payload.Rcl_74 = Fuel || "";
      payload.Rcl_76 = Remark || "";
      payload.Rcl_77 = Color || "";
      payload.Rcl_78 = "2026";
      payload.Rcl_79 = "1";
      payload.Rcl_82 = Scname || "";
      payload.Rcl_83 = Tlname || "";
      payload.Rcl_84 = Manager || "";
      payload.Rcl_92 = Branch || "";
      payload.Rcl_105 = Branch || "";
      switch (Modeofpayment) {
        case "Bank":
          payload.Rcl_13 = chequeNo || "";
          payload.Rcl_14 = chequeDate || "";
          payload.Rcl_15 = bankName || "";
          payload.Rcl_17 = bankAmt.toString();
          payload.Rcl_43 = bankAmt.toString();
          break;
        case "wallet":
          payload.Rcl_20 = walletName || "";
          payload.Rcl_133 = walletTxnCode || "";
          payload.Rcl_41 = walletAmt.toString();
          break;
        case "cash": {
          const notes = splitCashIntoNotes(cashAmt);
          const amt500 = notes[500] * 500;
          const amt200 = notes[200] * 200;
          const amt100 = notes[100] * 100;
          const amt50 = notes[50] * 50;
          const amt20 = notes[20] * 20;
          const amt10 = notes[10] * 10;
          const amt5 = notes[5] * 5;
          const totalCash =
            amt500 + amt200 + amt100 + amt50 + amt20 + amt10 + amt5;
          payload.Rcl_21 = "0";
          payload.Rcl_22 = "0";
          payload.Rcl_23 = "0";
          payload.Rcl_24 = "0";
          payload.Rcl_25 = notes[500].toString();
          payload.Rcl_26 = amt500.toString();
          payload.Rcl_27 = notes[200].toString();
          payload.Rcl_28 = amt200.toString();
          payload.Rcl_29 = notes[100].toString();
          payload.Rcl_30 = amt100.toString();
          payload.Rcl_31 = notes[50].toString();
          payload.Rcl_32 = amt50.toString();
          payload.Rcl_33 = notes[20].toString();
          payload.Rcl_34 = amt20.toString();
          payload.Rcl_35 = notes[10].toString();
          payload.Rcl_36 = amt10.toString();
          payload.Rcl_37 = notes[5].toString();
          payload.Rcl_38 = amt5.toString();
          payload.Rcl_40 = totalCash.toString();
          payload.Rcl_61 = totalCash.toString();
          break;
        }
        case "CreditCard":
          payload.Rcl_81 = ccName || "";
          payload.Rcl_17 = ccTxn || "";
          payload.Rcl_18 = ccLast4 || "";
          payload.Rcl_19 = ccType || "";
          payload.Rcl_115 = ccDate || "";
          payload.Rcl_42 = creditAmt.toString();
          break;
        case "DebitCard":
          payload.Rcl_132 = dcName || "";
          payload.Rcl_133 = dcTxn || "";
          payload.Rcl_134 = dcLast4 || "";
          payload.Rcl_19 = dcType || "";
          payload.Rcl_135 = dcDate || "";
          payload.Rcl_136 = debitAmt.toString();
          break;
        case "UPI":
          payload.Rcl_80 = upiBankName || "";
          payload.Rcl_70 = upiUtr || "";
          payload.Rcl_14 = upiDate || "";
          payload.Rcl_43 = upiAmt.toString();
          break;
        case "RTGS":
          payload.Rcl_80 = upiBankName || "";
          payload.Rcl_70 = upiUtr || "";
          payload.Rcl_14 = upiDate || "";
          payload.Rcl_43 = upiAmt.toString();
          break;
        default:
          break;
      }
      payload.Rcl_137 = filePath2 || "";
      payload.Rcl_138 = filePath1 || "";
      const response = await apiFetch(
        "/api/receipt/save",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await response.json();
      if (data.err === "0") {
        alert("✅ Receipt Saved Successfully");
        const receiptUnqid = data.unqid;
        try {
          const pdfRes = await apiFetch(
            `/api/receipt/print-pdf/${receiptUnqid}`,
          );
          const blob = await pdfRes.blob();
          const url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
        } catch (pdfErr) {
          console.error("PDF open failed", pdfErr);
        }
        console.log("Saving Branch ID:", Branch);
        navigate("/RajaReceiptGrid");
      } else {
        alert(data.msg || "Save failed");
      }
      console.log(payload);
    } catch (err) {
      console.error("❌ Save Error:", err);
      alert("❌ Save failed");
    }
  };

  //--------Exit Working
  const handleExit = () => {
    navigate("/RajaReceiptGrid");
  };
  const formatDateForInput = (ddmmyyyy) => {
    if (!ddmmyyyy) return "";
    const [d, m, y] = ddmmyyyy.split("/");
    return `${y}-${m}-${d}`;
  };

  // CONVERT FOR DATE FORMAT
  const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  //  NEW RECEIPT DATE useEffect (PLACE HERE)
  useEffect(() => {
    if (!editUnqid) {
      setReceiptDate(getTodayDate());
    }
  }, [editUnqid]);

  // ================= EDIT MODE LOAD =================
  useEffect(() => {
    if (!editUnqid) return;
    setIsEditing(true);

    const loadEditData = async () => {
      try {
        const response = await apiFetch(
          "/api/receipt/edit",
          { method: "POST", body: JSON.stringify({ rcl_2: editUnqid }) },
        );
        const res = await response.json();
        if (res.err !== "0") {
          alert("Failed to load receipt");
          return;
        }
        const d = res.data;
        /* ===== BASIC ===== */
        setReceiptno(d.receiptno || "");
        setReceiptDate(formatDateForInput(d.date));
        setTYPE(d.receipttype || "");
        setBranch(d.branchunq || "");
        setState(d.state || "");
        setCity(d.city || "");
        setArea(d.area || "");
        setAccessoriesInvoiceNo(d.invno || "");
        /* ===== CUSTOMER ===== */
        setCustomerName(d.cust || "");
        setCustomerSearch(d.accountcode || "");
        setAddress(d.address || "");
        setZipNo(d.zipno || "");
        setPANNo(d.panno || "");
        setAadharno(d.aadharno || "");
        setGSTIN(d.gstin || "");
        /* ===== MODEL ===== */
        setModel(d.modelunq || "");
        setVariant(d.varunq || "");
        setColor(d.color || "");
        setFuel(d.fuel || "");
        /* ===== SALES ===== */
        setScname(d.scunq || "");
        setScSearch(d.scname || "");
        setTlname(d.tlname || "");
        setManager(d.manager || "");
        /* ===== PAYMENT ===== */
        setModeofpayment(d.modeofpayment || "");
        setActivePayment(d.modeofpayment || "");
        setAmount(Number(d.receivedamt || 0));
        setBankAmt(Number(d.cheqamt || 0));
        setWalletName(d.walletname || "");
        setWalletTxnCode(d.transactioncode || "");
        setWalletAmt(Number(d.walletamt || 0));
        setCreditAmt(Number(d.creditcardamt || 0));
        setCashAmt(Number(d.totalcurrency || 0));
        setUpiAmt(Number(d.totalofbank || 0));
        /* ===== BANK ===== */
        /* ===== BANK ===== */
        /* ===== BANK ===== */
        if (d.bankunq) {
          setBankName(d.bankunq); // normal case (best)
        } else if (d.bank) {
          const match = bankList.find((b) => b.label === d.bank);
          setBankName(match?.value || "");
        }

        setChequeNo(d.chqno || "");
        setChequeDate(formatDateForInput(d.chqdate));
        setHypothecation(d.hpnname || "");
        setHypothecationBranch(d.hpnbranch || "");
        /* ===== CARD ===== */
        setCcName(d.creditcardname || "");
        setCcTxn(d.trnbal || "");
        setCcLast4(d.creditcardno || "");
        setCcType(d.creditcardtype || "");
        setCcDate(formatDateForInput(d.creditcarddate));
        /* ===== DEBIT CARD (ADD THIS) ===== */
        /* ===== DEBIT CARD ===== */
        setDcName(d.debitcardname || "");
        setDcTxn(d.debittransactioncode || "");
        setDcLast4(d.lastfourdigit || "");
        setDcType(d.creditcardtype || "");
        setDcDate(d.debitcarddate ? formatDateForInput(d.debitcarddate) : "");
        setDebitAmt(Number(d.debitcardamt || 0));
        setDebitAmt(Number(d.debitcardamt || 0));
        if (d.modeofpayment === "DebitCard") {
          setActivePayment("DebitCard");
          setOpenSection("DebitCard");
        }
        /* ===== UPI ===== */

        setUpiBankName(d.upibankname || "");
        setUpiUtr(d.mtr || "");
        setUpiDate(formatDateForInput(d.upidate));
        setUpiAmt(Number(d.upiamt || 0));

        if (d.modeofpayment === "UPI" || d.modeofpayment === "RTGS") {
          setActivePayment(d.modeofpayment);
          setOpenSection(d.modeofpayment);
        }
        /* ===== REMARK / FILE ===== */
        setRemark(d.remark || "");
        setFilePath1(d.pdf_path || "");

        setOpenSection(d.modeofpayment || null);
      } catch (err) {
        console.error("❌ Edit load failed", err);
        alert("Edit load failed");
      }
    };
    loadEditData();
  }, [editUnqid]);
  //---------------------UPDATE WORKING CODE
  const handleUpdateReceipt = async () => {
    try {
      const payload = {};
      const dateFields = [7, 14, 115, 135];
      for (let i = 1; i <= 138; i++) {
        payload[`Rcl_${i}`] = null;
      }
      [
        40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 58, 59, 60, 69, 75, 136,
      ].forEach((i) => {
        payload[`Rcl_${i}`] = "0";
      });
      payload.Rcl_2 = editUnqid;
      payload.Rcl_3 = userId || "";
      payload.Rcl_4 = ipAddress || "";
      payload.Rcl_6 = serverIp || "";
      payload.Rcl_7 = receiptDate || "";
      payload.Rcl_8 = AccessoriesInvoiceNo || "";
      payload.Rcl_9 = Receiptno || "";
      payload.Rcl_10 = Hypothecation || "";
      payload.Rcl_11 = CustomerName || "";
      payload.Rcl_12 = Amount?.toString() || "0";
      payload.Rcl_16 = Modeofpayment || "";
      payload.Rcl_51 = Amount.toString();
      payload.Rcl_58 = Amount.toString();
      payload.Rcl_66 = TYPE || "";
      payload.Rcl_71 = Model || "";
      payload.Rcl_73 = Variant || "";
      payload.Rcl_77 = Color || "";
      payload.Rcl_76 = Remark || "";
      payload.Rcl_105 = Branch || "";
      payload.Rcl_82 = Scname || "";
      payload.Rcl_83 = Tlname || "";
      payload.Rcl_84 = Manager || "";

      if (Modeofpayment === "Bank") {
        payload.Rcl_13 = chequeNo || "";
        payload.Rcl_14 = chequeDate || "";
        payload.Rcl_15 = bankName || "";
        payload.Rcl_43 = bankAmt.toString();
      }
      if (Modeofpayment === "wallet") {
        payload.Rcl_20 = walletName || "";
        payload.Rcl_133 = walletTxnCode || "";
        payload.Rcl_41 = walletAmt.toString();
      }
      if (Modeofpayment === "CreditCard") {
        payload.Rcl_81 = ccName || "";
        payload.Rcl_17 = ccTxn || "";
        payload.Rcl_18 = ccLast4 || "";
        payload.Rcl_19 = ccType || "";
        payload.Rcl_115 = ccDate || "";
        payload.Rcl_42 = creditAmt.toString();
      }
      if (Modeofpayment === "DebitCard") {
        payload.Rcl_132 = dcName || "";
        payload.Rcl_133 = dcTxn || "";
        payload.Rcl_134 = dcLast4 || "";
        payload.Rcl_19 = dcType || "";
        payload.Rcl_135 = dcDate || "";
        payload.Rcl_136 = debitAmt.toString();
      }
      if (Modeofpayment === "UPI" || Modeofpayment === "RTGS") {
        payload.Rcl_80 = upiBankName || "";
        payload.Rcl_70 = upiUtr || "";
        payload.Rcl_14 = upiDate || "";
        payload.Rcl_43 = upiAmt.toString();
      }
      payload.Rcl_137 = filePath2 || "";
      payload.Rcl_138 = filePath1 || "";

      const updateResponse = await apiFetch(
        "/api/receipt/update",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const updateData = await updateResponse.json();
      if (updateData.err === "0") {
        alert("✅ Receipt Updated Successfully");
        try {
          const pdfRes = await apiFetch(
            `/api/receipt/print-pdf/${editUnqid}`,
          );
          const blob = await pdfRes.blob();
          const url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
        } catch (pdfErr) {
          console.error("PDF open failed", pdfErr);
        }
        navigate("/RajaReceiptGrid");
      } else {
        alert(updateData.msg || "Update failed");
      }
    } catch (err) {
      console.error("❌ Update Error:", err);
      alert("❌ Update failed");
    }
  };
  useEffect(() => {
    fetchCardList();
  }, []);

  const fetchCardList = async () => {
    try {
      const response = await apiFetch(
        "/api/receipt/card",
        { method: "POST", body: JSON.stringify({}) },
      );
      const data = await response.json();
      if (data.err === "0") {
        setCardList(data.list.map((c) => ({ value: c.data, label: c.value })));
      }
    } catch (err) {
      console.error("Card fetch failed", err);
    }
  };
  useEffect(() => {
    fetchBankList();
  }, []);

  const fetchBankList = async () => {
    try {
      const response = await apiFetch(
        "/api/receipt/banks",
      );
      const data = await response.json();
      if (data.err === "0") {
        setBankList(data.list.map((b) => ({ value: b.data, label: b.value })));
      }
    } catch (err) {
      console.error("Bank fetch failed", err);
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">RECEIPT</div>
          {/* ---------------- FORM ROW 1 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Receipt No</label>
              <input
                type="text"
                value={Receiptno}
                readOnly
                style={{ background: "#eee", fontWeight: "bold" }}
              />
            </div>
            <div className="form-column">
              <label>Branch</label>
              <Select
                options={BranchList}
                value={BranchList.find((b) => b.value === Branch) || null}
                onChange={(selected) => {
                  setBranch(selected?.value || "");
                }}
                placeholder="Select Branch"
                styles={selectStyles}
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-column">
              <label>Type</label>
              <Select
                options={TypeList}
                value={TypeList.find((t) => t.value === TYPE) || null}
                onChange={(selected) => setTYPE(selected?.value || "")}
                placeholder="Select Type"
                styles={selectStyles}
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-column">
              <label>Date</label>
              <input
                type="date"
                value={receiptDate}
                readOnly
                style={{ background: "#eee" }}
              />
            </div>
          </div>
          {/* ---------------- FORM ROW 2 ---------------- */}
          <div className="form-row two-col-row">
            <div className="form-column">
              <label>Customer Name</label>
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <div style={{ position: "relative", flex: 1 }}>
                  <input
                    type="text"
                    placeholder="Type customer name..."
                    value={customerSearch}
                    onChange={handleCustomerInput}
                    onKeyDown={(e) => {
                      // Allow control keys
                      if (
                        e.key === "Backspace" ||
                        e.key === "Delete" ||
                        e.key === "ArrowLeft" ||
                        e.key === "ArrowRight" ||
                        e.key === "Tab"
                      ) {
                        return;
                      }

                      // Allow only alphabets & space
                      if (!/^[a-zA-Z ]$/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onFocus={() =>
                      customerSuggestions.length &&
                      setShowCustomerDropdown(true)
                    }
                  />

                  {showCustomerDropdown && customerSuggestions.length > 0 && (
                    <ul
                      style={{
                        position: "absolute",
                        top: "42px",
                        left: 0,
                        right: 0,
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        maxHeight: "200px",
                        overflowY: "auto",
                        zIndex: 9999,
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                        textAlign: "left",
                      }}
                    >
                      {customerSuggestions.map((c, i) => (
                        <li
                          key={i}
                          style={{
                            padding: "8px 10px",
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            setCustomerSearch(c.value);
                            setCustomerName(c.data);
                            setShowCustomerDropdown(false);
                            setAddress(c.m1_11 || "");
                            setZipNo(c.zipcode || "");
                            setFuel(c.fuel || "");
                            setState(c.state || "");
                            setCity(c.cityname || "");
                            setArea(c.areaname || "");
                            setScname(c.sp_756 || "");
                            setTlname(c.headname || "");
                            setManager(c.manager || "");
                            setPANNo(c.m1_40 || "");
                            setAadharno(c.m1_48 || "");
                            setGSTIN(c.gstin || "");
                          }}
                        >
                          <b>{c.value}</b>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                <button
                  type="button"
                  onClick={() => setShowAccountModal(true)}
                  style={{
                    width: "38px",
                    height: "38px",
                    flexShrink: 0,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  +
                </button>
              </div>
            </div>
            <div className="form-column">
              <label>Address</label>
              <input
                type="text"
                value={Address}
                readOnly
                style={{ background: "#eee" }}
              />
            </div>
          </div>
          {/* ---------------- FORM ROW 3 ---------------- */}

          <div className="form-row">
            <div className="form-column">
              <label>Payment Type</label>
              <div className="inline-radio-group">
                <label className="inline-radio">
                  <input
                    type="radio"
                    name="paymentType"
                    value="WITH"
                    checked={paymentType === "WITH"}
                    onChange={(e) => setPaymentType(e.target.value)}
                  />
                  <span className="radio-dot"></span>
                  <span>With Payment</span>
                </label>
                <label className="inline-radio">
                  <input
                    type="radio"
                    name="paymentType"
                    value="WITHOUT"
                    checked={paymentType === "WITHOUT"}
                    onChange={(e) => setPaymentType(e.target.value)}
                  />
                  <span className="radio-dot"></span>
                  <span>Without Payment</span>
                </label>
                <label className="inline-radio">
                  <input
                    type="radio"
                    name="paymentType"
                    value="ONLINE"
                    checked={paymentType === "ONLINE"}
                    onChange={(e) => setPaymentType(e.target.value)}
                  />
                  <span className="radio-dot"></span>
                  <span>Online</span>
                </label>
              </div>
            </div>
            <div className="form-column">
              <label>PAN No</label>
              <input
                type="text"
                value={PANNo}
                readOnly
                style={{ background: "#eee" }}
              />
            </div>
            <div className="form-column">
              <label>Aadhar Number</label>
              <input
                type="text"
                value={Aadharno}
                readOnly
                style={{ background: "#eee" }}
              />
            </div>
            <div className="form-column">
              <label>GSTIN</label>
              <input
                type="text"
                value={GSTIN}
                readOnly
                style={{ background: "#eee" }}
              />
            </div>
          </div>
          {/* ---------------- FORM ROW 4 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Accessories Invoice No</label>
              <input
                type="text"
                value={AccessoriesInvoiceNo}
                onChange={(e) =>
                  setAccessoriesInvoiceNo(allowNumbers(e.target.value))
                }
              />
            </div>
            <div className="form-column">
              <label>State</label>
              <Select
                options={StateList}
                value={StateList.find((s) => s.value === State) || null}
                onChange={(selected) => {
                  setState(selected?.value || "");
                  setCity("");
                  setArea("");
                  setCityList([]);
                  setAreaList([]);
                }}
                placeholder="Select State"
                styles={selectStyles}
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-column">
              <label>City</label>

              <div className="city-wrapper">
                <div className="city-select">
                  <Select
                    options={CityList}
                    value={CityList.find((c) => c.value === City) || null}
                    onChange={(selected) => {
                      setCity(selected?.value || "");
                      setArea("");
                      setAreaList([]);
                    }}
                    placeholder="Select City"
                    styles={selectStyles}
                    isSearchable
                    isDisabled={!State}
                  />
                </div>

                <button
                  type="button"
                  className="city-add-btn"
                  onClick={() => {
                    if (!State) {
                      alert("Please select State first");
                      return;
                    }
                    setCityPopupSource("MAIN");
                    setShowCityModal(true);
                  }}
                >
                  +
                </button>
              </div>
            </div>

            <div className="form-column">
              <label>Area</label>
              <Select
                options={AreaList}
                value={AreaList.find((a) => a.value === Area) || null}
                onChange={(selected) => {
                  setArea(selected?.value || "");
                }}
                placeholder="Select Area"
                styles={selectStyles}
                isSearchable
                isDisabled={!City}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
          </div>
          {/* ---------------- FORM ROW 5 ---------------- */}
          <div className="form-row model-row">
            <div className="form-column">
              <label>Zip No</label>
              <input
                type="text"
                value={ZipNo}
                onChange={(e) => setZipNo(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-column">
              <label>Model</label>
              <Select
                options={ModelList}
                value={ModelList.find((m) => m.value === Model) || null}
                onChange={(selected) => {
                  setModel(selected?.value || "");
                  setVariant("");
                  setVariantList([]);
                }}
                placeholder="Select Model"
                styles={selectStyles}
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-column ">
              <label>Variant</label>
              <Select
                options={VariantList}
                value={VariantList.find((v) => v.value === Variant) || null}
                onChange={(selected) => setVariant(selected?.value || "")}
                placeholder="Select Variant"
                styles={selectStyles}
                isSearchable
                isDisabled={!Model}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-column">
              <label>Color</label>
              <Select
                options={ColorList}
                value={ColorList.find((c) => c.value === Color) || null}
                onChange={(selected) => setColor(selected?.value || "")}
                placeholder="Select Color"
                styles={selectStyles}
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
          </div>
          {/* ---------------- FORM ROW 6 ---------------- */}
          <div className="form-row model-row">
            <div className="form-column">
              <label>Fuel</label>
              <input
                type="text"
                value={Fuel}
                onChange={(e) => setFuel(allowAlphabets(e.target.value))}
              />
            </div>
            <div className="form-column">
              <label>Sale Consultant</label>
              <div className="autocomplete-wrapper">
                <input
                  type="text"
                  placeholder="Type sales consultant..."
                  value={scSearch}
                  onChange={handleScInput}
                  onKeyDown={(e) => {
                    // Allow control keys
                    if (
                      e.key === "Backspace" ||
                      e.key === "Delete" ||
                      e.key === "ArrowLeft" ||
                      e.key === "ArrowRight" ||
                      e.key === "Tab"
                    ) {
                      return;
                    }

                    // Allow only alphabets & space
                    if (!/^[a-zA-Z ]$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onFocus={() =>
                    scSuggestions.length && setShowScDropdown(true)
                  }
                />
                {showScDropdown && scSuggestions.length > 0 && (
                  <ul className="autocomplete-list">
                    {scSuggestions.map((sc, i) => (
                      <li
                        key={i}
                        onClick={() => {
                          setScSearch(sc.label);
                          setScname(sc.value);
                          setShowScDropdown(false);
                          loadTlManagerBySc(sc.value);
                        }}
                      >
                        {sc.label}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
            <div className="form-column">
              <label>Team Leader</label>
              <input
                type="text"
                value={Tlname}
                readOnly
                style={{ background: "#eee" }}
              />
            </div>
            <div className="form-column">
              <label>Manager</label>
              <input
                type="text"
                value={Manager}
                readOnly
                style={{ background: "#eee" }}
              />
            </div>
          </div>
          {/* ---------------- FORM ROW 7 ---------------- */}
          <div className="form-row model-row">
            <div className="form-column">
              <label>Hypothecation</label>
              <div className="hypo-wrapper">
                <Select
                  className="rs-control"
                  classNamePrefix="rs"
                  options={HypothecationList}
                  value={
                    HypothecationList.find((h) => h.value === Hypothecation) ||
                    null
                  }
                  onChange={(selected) => {
                    setHypothecation(selected?.value || "");
                    setHypothecationBranch("");
                  }}
                  placeholder="Select Hypothecation"
                  styles={selectStyles}
                  isSearchable
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />

                <button
                  type="button"
                  onClick={() => setshowHypothecationModal(true)}
                  style={{
                    width: "38px",
                    height: "38px",
                    flexShrink: 0,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  +
                </button>
              </div>
            </div>
            <div className="form-column">
              <label>Hypothecation Branch</label>
              <Select
                className="rs-control"
                classNamePrefix="rs"
                options={HypothecationBranchList}
                value={
                  HypothecationBranchList.find(
                    (b) => b.value === HypothecationBranch,
                  ) || null
                }
                onChange={(selected) =>
                  setHypothecationBranch(selected?.value || "")
                }
                placeholder="Select Hypothecation Branch"
                styles={selectStyles}
                isSearchable
                isDisabled={!Hypothecation}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-column">
              <label>Amount Received</label>
              <input
                type="number"
                value={Amount}
                onChange={(e) => {
                  const val = Number(e.target.value || 0);
                  setAmount(val);

                  // fill active payment
                  if (activePayment === "Bank") setBankAmt(val);
                  if (activePayment === "wallet") setWalletAmt(val);
                  if (activePayment === "CreditCard") setCreditAmt(val);
                  if (activePayment === "DebitCard") setDebitAmt(val);
                  if (activePayment === "cash") {
                    setCashAmt(val);
                    setOpenSection("cash");
                  }
                  if (activePayment === "UPI") setUpiAmt(val);
                  if (activePayment === "RTGS") setUpiAmt(val);
                  setOpenSection(activePayment);
                }}
              />
            </div>
            <div className="form-column">
              <label>Mode Of Payment</label>
              <Select
                className="rs-control"
                classNamePrefix="rs"
                options={ModeOfPaymentList}
                value={
                  ModeOfPaymentList.find((m) => m.value === Modeofpayment) ||
                  null
                }
                onChange={(selected) => {
                  const value = selected?.value || "";
                  setModeofpayment(value);
                  setActivePayment(value);
                  setOpenSection(value);
                }}
                placeholder="Select Mode Of Payment"
                styles={selectStyles}
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
          </div>
          {/* ---------------- FORM ROW 8 ---------------- */}
          <div className="form-row model-row">
            <div className="form-column variant-span">
              <label>Remark</label>
              <input
                type="text"
                value={Remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Upload Image</label>
              <input
                type="file"
                onChange={(e) => setImageUpload(e.target.files[0])}
              />
              <button
                type="button"
                className="btn-upload"
                onClick={async () => {
                  const path = await uploadFile(imageUpload);
                  setFilePath1(path);
                  alert("Image Uploaded Successfully");
                }}
              >
                Upload Image
              </button>
            </div>

            <div className="form-column"></div>
          </div>
          <br />

          <>
            <SectionHeader
              title="Bank"
              icon="fa fa-bank"
              amount={bankAmt}
              open={openSection === "Bank"}
              onToggle={() =>
                setOpenSection(openSection === "Bank" ? null : "Bank")
              }
            />

            <BankSection
              open={openSection === "Bank"}
              amount={bankAmt}
              onAmountChange={(val) => {
                setBankAmt(val);
                setAmount(val);
              }}
              bankName={bankName}
              setBankName={setBankName}
              chequeNo={chequeNo}
              setChequeNo={setChequeNo}
              chequeDate={chequeDate}
              setChequeDate={setChequeDate}
              bankList={bankList} // ✅ ADD
              selectStyles={selectStyles} // ✅ ADD
            />
          </>

          <>
            <SectionHeader
              title="Wallet"
              icon="fas fa-wallet"
              amount={walletAmt}
              open={openSection === "wallet"}
              onToggle={() =>
                setOpenSection(openSection === "wallet" ? null : "wallet")
              }
            />

            <WalletSection
              open={openSection === "wallet"}
              amount={walletAmt}
              onAmountChange={(val) => {
                setWalletAmt(val);
                setAmount(val);
              }}
              walletName={walletName}
              setWalletName={setWalletName}
              walletTxnCode={walletTxnCode}
              setWalletTxnCode={setWalletTxnCode}
            />
          </>

          <>
            <SectionHeader
              title="Credit Card"
              icon="fas fa-credit-card"
              amount={creditAmt}
              open={openSection === "CreditCard"}
              onToggle={() =>
                setOpenSection(
                  openSection === "CreditCard" ? null : "CreditCard",
                )
              }
            />

            <CreditCardSection
              open={openSection === "CreditCard"}
              amount={creditAmt}
              onAmountChange={(val) => {
                setCreditAmt(val);
                setAmount(val);
              }}
              ccName={ccName}
              setCcName={setCcName}
              ccTxn={ccTxn}
              setCcTxn={setCcTxn}
              ccLast4={ccLast4}
              setCcLast4={setCcLast4}
              ccType={ccType}
              setCcType={setCcType}
              ccDate={ccDate}
              setCcDate={setCcDate}
              cardList={cardList} // ✅ added
              selectStyles={selectStyles} // ✅ added
            />
          </>

          <>
            <SectionHeader
              title="Debit Card"
              icon="fas fa-credit-card"
              amount={debitAmt}
              open={openSection === "DebitCard"}
              onToggle={() =>
                setOpenSection(openSection === "DebitCard" ? null : "DebitCard")
              }
            />

            <DebitCardSection
              open={openSection === "DebitCard"}
              amount={debitAmt}
              onAmountChange={(val) => {
                setDebitAmt(val);
                setAmount(val);
              }}
              dcName={dcName}
              setDcName={setDcName}
              dcTxn={dcTxn}
              setDcTxn={setDcTxn}
              dcLast4={dcLast4}
              setDcLast4={setDcLast4}
              dcType={dcType}
              setDcType={setDcType}
              dcDate={dcDate}
              setDcDate={setDcDate}
              cardList={cardList} // ✅ added
              selectStyles={selectStyles} // ✅ added
            />
          </>

          <>
            <SectionHeader
              title="Cash"
              icon="fas fa-rupee-sign"
              amount={cashAmt}
              open={openSection === "cash"}
              onToggle={() =>
                setOpenSection(openSection === "cash" ? null : "cash")
              }
            />
            <CashSection
              open={openSection === "cash"}
              amountReceived={Amount}
              onAmountChange={(val) => {
                setCashAmt(val);
                setAmount(val);
              }}
            />
          </>

          <>
            <SectionHeader
              title={openSection === "RTGS" ? "RTGS / NEFT / IMPS" : "UPI"}
              icon="fas fa-mobile-alt"
              amount={upiAmt}
              open={openSection === "UPI" || openSection === "RTGS"}
              onToggle={() =>
                setOpenSection(
                  openSection === "UPI" || openSection === "RTGS"
                    ? null
                    : Modeofpayment,
                )
              }
            />

            <UpiSection
              open={openSection === "UPI" || openSection === "RTGS"}
              amount={upiAmt}
              onAmountChange={(val) => {
                setUpiAmt(val);
                setAmount(val);
              }}
              upiBankName={upiBankName}
              setUpiBankName={setUpiBankName}
              upiUtr={upiUtr}
              setUpiUtr={setUpiUtr}
              upiDate={upiDate}
              setUpiDate={setUpiDate}
              bankList={bankList} // ✅ ADD
              selectStyles={selectStyles} // ✅ ADD
            />
          </>

          {/* ---------------- BUTTONS ---------------- */}
          <div style={buttonContainerStyle}>
            {!isEditing && (
              <button
                style={buttonStyle("#4caf50")}
                onClick={handleSaveReceipt}
              >
                Save
              </button>
            )}
            {isEditing && (
              <button
                style={buttonStyle("#2e20abff")}
                onClick={handleUpdateReceipt}
              >
                Update
              </button>
            )}
            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      {/* ================== STYLES ================== */}
      <style>
        {`
/* ================== PAGE LAYOUT ================== */
/* === CITY FULL WIDTH FIX === */
.city-wrapper {
  display: grid;
  grid-template-columns: 1fr 40px;
  gap: 6px;
  align-items: center;
}
/* ================== REACT-SELECT MATCH INPUT STYLE ================== */
.rs__control {
  height: 40px !important;
  min-height: 40px !important;
  border: 1px solid #ccc !important;
  border-radius: 5px !important;
  box-shadow: none !important;
}

.rs__value-container {
  padding: 0 8px !important;
  height: 40px !important;
}

.rs__placeholder,
.rs__single-value {
  line-height: 40px !important;
  font-size: 14px !important;
}

.rs__indicators {
  height: 40px !important;
}

.rs__indicator-separator {
  display: none;
}

/* ================== HYPOTHECATION WRAPPER ================== */
.hypo-wrapper {
  display: grid;
  grid-template-columns: 1fr 40px;
  gap: 6px;
  align-items: center;
}

.hypo-wrapper button {
  height: 40px;
  width: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: #fff;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.hypo-wrapper button:hover {
  background: #f4f4f4;
}

.city-select {
  width: 100%;
}

.city-select .react-select__control {
  height: 40px;
}

.city-add-btn {
  height: 40px;
  width: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: #fff;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.city-add-btn:hover {
  background: #f4f4f4;
}

.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 10px;
}

.container {
  width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 15px;
}

/* ================== HEADER ================== */
.header {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 15px;
  background: #8B1E3F;
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ================== FORM GRID (DESKTOP = 4) ================== */
.form-row,
.model-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
  margin-bottom: 15px;
}

.two-col-row {
  grid-template-columns: repeat(2, 1fr);
}

.variant-span {
  grid-column: span 2;
}

.form-column {
  display: flex;
  flex-direction: column;
}

/* ================== INPUTS ================== */
label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

input,
select {
  height: 40px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  width: 100%;
}

/* ================== AUTOCOMPLETE ================== */
.autocomplete-wrapper {
  position: relative;
}

.autocomplete-list {
  position: absolute;
  top: 42px;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 9999;
  list-style: none;
  padding: 0;
  margin: 0;
}

.autocomplete-list li {
  padding: 8px 10px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
}

.autocomplete-list li:hover {
  background: #f5f5f5;
}

/* ================== RADIO ================== */
.inline-radio-group {
  display: flex;
  gap: 20px;
  margin-top: 8px;
}

.inline-radio {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
}

.inline-radio input {
  display: none;
}

.radio-dot {
  width: 14px;
  height: 14px;
  border: 2px solid #d84315;
  border-radius: 50%;
  margin-right: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.radio-dot::after {
  content: "";
  width: 8px;
  height: 8px;
  background: #d84315;
  border-radius: 50%;
  transform: scale(0);
}

.inline-radio input:checked + .radio-dot::after {
  transform: scale(1);
}

/* ================== BUTTONS ================== */
.button-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
}

.btn-exit {
  background: #a20d0d;
color: #fff;
  padding: 10px 28px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
}
.btn-exit:hover {
  background: #6d1631;
}
/* ================== PAYMENT SECTIONS ================== */
.bank-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
}

.wallet-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}

.card-row {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 15px;
}

/* ================== MODALS ================== */
/* ================== COMMON MODAL ================== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

/* Container */
.account-modal,
.city-modal,
.area-modal,
.hypothecation-modal {
  background: #fff;
  border-radius: 6px;
  width: 850px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,.35);
}

/* ================== MODAL HEADER ================== */
.modal-header {
  background: #8B1E3F;
  color: #fff;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header .close-btn {
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
}

/* ================== MODAL BODY ================== */
.modal-body {
  padding: 15px;
  background: #fafafa;
}

.modal-grid,
.city-grid,
.area-grid,
.hypothecation-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}
.modal-footer {
  padding: 12px;
  display: flex;
  justify-content: center;
  gap: 12px;
  border-top: 1px solid #ddd;
  background: #f4f4f4;
}
/* ================== MODAL FOOTER ================== */
.modal-footer {
  padding: 12px;
  display: flex;
  justify-content: center;
  gap: 12px;
  border-top: 1px solid #ddd;
  background: #f4f4f4;
}

/* ================== MODAL BUTTONS ================== */
.btn-save {
  background: #2e7d32;
  color: #fff;
  padding: 8px 25px;
  border: none;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
}

.btn-save:hover {
  background: #1b5e20;
}

.btn-cancel {
  background: #c62828;
  color: #fff;
  padding: 8px 25px;
  border: none;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
}

.btn-cancel:hover {
  background: #b71c1c;
}
/* ================== TABLET (iPAD) ================== */
@media (max-width: 1024px) {
  .form-row,
  .model-row {
    grid-template-columns: repeat(2, 1fr);
  }

  .bank-row,
  .wallet-row,
  .card-row {
    grid-template-columns: repeat(2, 1fr);
  }

  .modal-grid,
  .city-grid,
  .area-grid,
  .hypothecation-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ================== MOBILE ================== */
@media (max-width: 768px) {
  .form-row,
  .model-row,
  .two-col-row {
    grid-template-columns: 1fr !important;
  }

  .variant-span {
    grid-column: span 1;
  }

  .bank-row,
  .wallet-row,
  .card-row {
    grid-template-columns: 1fr;
  }

  .inline-radio-group {
    flex-direction: column;
  }

  .account-modal,
  .city-modal,
  .area-modal,
  .hypothecation-modal {
    width: 95%;
    max-height: 90vh;
    overflow-y: auto;
  }

  .modal-grid,
  .city-grid,
  .area-grid,
  .hypothecation-grid {
    grid-template-columns: 1fr;
  }
}
  /* ================= FULL RESPONSIVE GRID SYSTEM ================= */

/* Desktop large (default already 4 columns) */

/* Laptop */
@media (max-width: 1400px) {
  .form-row,
  .model-row {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* iPad */
@media (max-width: 1024px) {
  .form-row,
  .model-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile */
@media (max-width: 768px) {
  .form-row,
  .model-row,
  .two-col-row {
    grid-template-columns: 1fr !important;
  }

  .variant-span {
    grid-column: span 1;
  }
}

/* ================= PERFECT BUTTON CENTER FIX ================= */

.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  flex-wrap: nowrap;
  width: 100%;
}

.button-container button {
  min-width: 120px;
  padding: 10px 24px;
  border-radius: 6px;
  font-weight: bold;
  white-space: nowrap;
}

/* Stop vertical stacking */
@media (max-width: 768px) {
  .button-container {
    flex-direction: row !important;
  }

  .button-container button {
    min-width: 100px;
    padding: 10px 18px;
  }
}

/* ================= POPUP MOBILE AUTO FIT (NO DESIGN CHANGE) ================= */

@media (max-width: 768px) {
  .account-modal,
  .city-modal,
  .area-modal,
  .hypothecation-modal {
    width: 95% !important;
    max-height: 92vh;
    overflow-y: auto;
  }
}

/* ================= PAYMENT GRID RESPONSIVE ================= */

@media (max-width: 1400px) {
  .bank-row {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 1024px) {
  .bank-row,
  .wallet-row,
  .card-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .bank-row,
  .wallet-row,
  .card-row {
    grid-template-columns: 1fr;
  }
}

`}
      </style>

      {showAccountModal && (
        <div className="modal-overlay">
          <div className="account-modal">
            {/* HEADER */}
            <div className="modal-header">
              <span>Add Account</span>
              <span
                className="close-btn"
                onClick={() => setShowAccountModal(false)}
              >
                ✖
              </span>
            </div>
            <div className="modal-body">
              <div className="modal-grid">
                <div>
                  <label>
                    Title<span>*</span>
                  </label>
                  <input
                    value={accTitle}
                    onChange={(e) => setAccTitle(e.target.value)}
                  />
                </div>
                <div>
                  <label>
                    Name<span>*</span>
                  </label>
                  <input
                    value={accName}
                    onChange={(e) => setAccName(e.target.value)}
                  />
                </div>
                <div>
                  <label>Father's Name</label>
                  <input type="text" />
                </div>
                <div>
                  <label>Email ID</label>
                  <input
                    value={accEmail}
                    onChange={(e) => setAccEmail(e.target.value)}
                  />
                </div>
                <div>
                  <label>
                    Address<span>*</span>
                  </label>
                  <input
                    value={accAddress}
                    onChange={(e) => setAccAddress(e.target.value)}
                  />
                </div>
                <div>
                  <label>
                    State<span>*</span>
                  </label>

                  <select
                    value={modalState}
                    onChange={(e) => setModalState(e.target.value)}
                  >
                    <option value="">Select</option>
                    {StateList.map((s, i) => (
                      <option key={i} value={s.value}>
                        {s.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label>
                    City<span>*</span>
                  </label>
                  <div style={{ display: "flex", gap: "6px" }}>
                    <select
                      value={modalCity}
                      onChange={(e) => setModalCity(e.target.value)}
                      disabled={!modalState}
                    >
                      <option value="">Select</option>
                      {modalCityList.map((c, i) => (
                        <option key={i} value={c.value}>
                          {c.label}
                        </option>
                      ))}
                    </select>

                    <button
                      type="button"
                      onClick={() => setShowCityModal(true)}
                      style={{
                        width: "38px",
                        height: "38px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      +
                    </button>
                  </div>
                </div>
                <div>
                  <label>
                    Area<span>*</span>
                  </label>
                  <div style={{ display: "flex", gap: "6px" }}>
                    <select
                      value={modalArea}
                      onChange={(e) => setModalArea(e.target.value)}
                      disabled={!modalCity}
                    >
                      <option value="">Select</option>
                      {modalAreaList.map((a, i) => (
                        <option key={i} value={a.value}>
                          {a.label}
                        </option>
                      ))}
                    </select>

                    <button
                      type="button"
                      onClick={() => setshowAreaModal(true)}
                      style={{
                        width: "38px",
                        height: "38px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      +
                    </button>
                  </div>
                </div>
                <div>
                  <label>Zip</label>
                  <input
                    value={accZip}
                    onChange={(e) => setAccZip(e.target.value)}
                  />
                </div>
                <div>
                  <label>
                    Mobile No<span>*</span>
                  </label>
                  <input
                    value={accMobile}
                    onChange={(e) => setAccMobile(e.target.value)}
                  />
                </div>
                <div>
                  <label>GSTIN</label>
                  <input
                    value={accGSTIN}
                    onChange={(e) => setAccGSTIN(e.target.value)}
                  />
                </div>
                <div>
                  <label>Birth Anniversary</label>
                  <input
                    type="date"
                    value={accDob}
                    onChange={(e) => setAccDob(e.target.value)}
                  />
                </div>
                <div>
                  <label>Marriage Anniversary</label>
                  <input
                    type="date"
                    value={accAnniv}
                    onChange={(e) => setAccAnniv(e.target.value)}
                  />
                </div>
                <div>
                  <label>Aadhar No</label>
                  <input
                    value={accAadhar}
                    onChange={(e) => setAccAadhar(e.target.value)}
                  />
                </div>
                <div>
                  <label>PAN No</label>
                  <input
                    value={accPAN}
                    onChange={(e) => setAccPAN(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-save" onClick={saveAccountFromModal}>
                Save
              </button>
              <button
                className="btn-cancel"
                onClick={() => setShowAccountModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {/* For City PopUp */}
      {showCityModal && (
        <div className="modal-overlay">
          <div className="city-modal">
            <div className="modal-header">
              <span>Add City</span>
              <span
                className="close-btn"
                onClick={() => setShowCityModal(false)}
              >
                ✖
              </span>
            </div>
            <div className="modal-body">
              <div className="city-grid">
                <div>
                  <label>
                    State<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={newCityStateName}
                    readOnly
                    style={{ background: "#eee", fontWeight: "bold" }}
                  />
                </div>
                <div>
                  <label>
                    City<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={newCityName}
                    onChange={(e) => setNewCityName(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn-save"
                onClick={() =>
                  cityPopupSource === "MAIN" ? saveMainCity() : saveCity()
                }
              >
                Save
              </button>

              {/* <button className="btn-save"  onClick={saveCity}>
                Save
              </button> */}
              <button
                className="btn-cancel"
                onClick={() => setShowCityModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {/* For Area PopUp */}
      {showAreaModal && (
        <div className="modal-overlay">
          <div className="area-modal">
            <div className="modal-header">
              <span>Add Area</span>
              <span
                className="close-btn"
                onClick={() => setshowAreaModal(false)}
              >
                ✖
              </span>
            </div>
            <div className="modal-body">
              <div className="area-grid">
                <div>
                  <label>
                    City<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={newAreaCityName}
                    readOnly
                    style={{ background: "#eee", fontWeight: "bold" }}
                  />
                </div>
                <div>
                  <label>
                    Area<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={newAreaName}
                    onChange={(e) => setNewAreaName(e.target.value)}
                    placeholder="Enter Area"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-save" onClick={saveArea}>
                Save
              </button>
              <button
                className="btn-cancel"
                onClick={() => setshowAreaModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {/* For Hypothecation  PopUp */}
      {showHypothecationModal && (
        <div className="modal-overlay">
          <div className="hypothecation-modal">
            <div className="modal-header">
              <span>Add Hypothecation</span>
              <span
                className="close-btn"
                onClick={() => setshowHypothecationModal(false)}
              >
                ✖
              </span>
            </div>
            <div className="modal-body">
              <div className="hypothecation-grid">
                <div>
                  <label>
                    Bank Name<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={hypoBankName}
                    onChange={(e) => setHypoBankName(e.target.value)}
                  />
                </div>
                <div>
                  <label>
                    Bank Address<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={hypoBankAddress}
                    onChange={(e) => setHypoBankAddress(e.target.value)}
                    placeholder="Enter Bank Address"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-save" onClick={savehpn}>
                Save
              </button>
              <button
                className="btn-cancel"
                onClick={() => setshowHypothecationModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default RajaReceiptDetailsDesign;
